module.exports = __webpack_public_path__ + "assets/ce9d49cf20af039a1c3f03f0c3697917.jpg";